// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModalSampleView_section__xUQlu {
  margin-top: 20px;
  margin-bottom: 20px;
}

.ModalSampleView_center__gsHE9 {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/examples/views/ModalSampleView/ModalSampleView.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;AACF","sourcesContent":[".section {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.center {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  align-items: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `ModalSampleView_section__xUQlu`,
	"center": `ModalSampleView_center__gsHE9`
};
export default ___CSS_LOADER_EXPORT___;
